export const items = [
  {
    'title':  'Нагадування про урок в Telegram',
    'el': 'switcher',
  },
  {
    'title': 'Час нагадування',
    'el': 'select',
  },
  {
    'title': 'Ваш часовий пояс',
    'el': 'timezone',
    'hint': 'Розклад і час у нагадуваннях показуємо за цим поясом. Перехід на літній/зимовий час враховується автоматично.',
  }
];